const styles = {
  container: incrementHeight => {
    return {
      position: 'relative',
      width: '100%',
      height: incrementHeight ? 65 : 55,
      outline: 0,
      display: 'block',
      fontFamily: 'Roboto, sans-serif',
      ':focus': {
        outline: 0
      }
    }
  },
  input: (focus, showErrorLine, disabled) => {
    return {
      width: '100%',
      fontSize: 16,
      height: 25,
      position: 'relative',
      top: 20,
      borderTop: 0,
      paddingLeft: 2,
      paddingBottom: 1,
      borderLeft: 0,
      borderRight: 0,
      borderRadius: 0,
      outline: 'none',
      boxShadow: 'none',
      WebkitAppearance: 'none',
      borderBottom: focus
        ? '2px solid #337ab7'
        : showErrorLine
          ? '2px solid red'
          : '1px solid rgba(0, 0, 0, 0.1)',
      transition: focus ? 'border-color 600ms ease' : 'none',
      color: disabled ? 'rgb(168, 168, 168)' : '#000'
    }
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/components/inputs/styles/field-style.js